import React from 'react';

const PasswordStrength = ({ requirements, password }) => {

    const parsedRequirements = requirements.map((req) => ({
        ...req,
        regex: new RegExp(req.regex),
    }));

    const metConditions = parsedRequirements.filter((req) =>
        req.regex.test(password)
    ).length;

    const getStrengthColor = () => {
        if (password.length < 3) return "red";
        if (metConditions < requirements.length) return "orange";
        return "green";
    };

    return (
        <>
            {requirements.map((e, i) => {
                return (
                    <span key={i} className={getStrengthColor()}></span>
                )
            })}
        </>
    )
}

export default PasswordStrength;
